<template>
    <div v-if="show">
        <div class="context-menu-backdrop" @click.self="close()" @contextmenu.self="close()"></div>
        <div class="context-menu--container" :style="style">
            <div class="context-menu">
                <template v-if="eventValues.personId">
                    <div class="dropright">
                        <a
                            class="dropdown-item dropdown-toggle"
                            href="#"
                            role="button"
                            id="contextMenuAbsences"
                            data-toggle="dropdown"
                            :aria-haspopup="true"
                            :aria-expanded="false"
                        >
                            <i class="icofont-adjust"></i>{{ trans('Absence') }}
                        </a>

                        <div class="dropdown-menu" aria-labelledby="contextMenuAbsences">
                            <a
                                class="dropdown-item"
                                v-for="absence of absence_types"
                                @click.stop="onAbsenceChange(absence.id)"
                                href="#"
                            >
                                <template v-if="absence.icon">
                                    <i :class="getIcon(absence.icon)"></i>
                                </template>
                                {{ absence.title }}
                            </a>
                        </div>
                    </div>
                </template>
                <template v-if="eventValues.taskId">
                    <div class="dropright">
                        <a
                            class="dropdown-item dropdown-toggle"
                            href="#"
                            role="button"
                            id="contextMenuStatuses"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <i class="icofont-adjust"></i>{{ trans('Status') }}
                        </a>

                        <div class="dropdown-menu" aria-labelledby="contextMenuStatuses">
                            <a
                                class="dropdown-item"
                                v-for="status of task_statuses"
                                @click.prevent="onStatusChange(status.id)"
                                href="#"
                            >
                                {{ status.title }}
                            </a>
                        </div>
                    </div>
                    <a
                        class="dropdown-item"
                        @click.prevent="
                            task_finished_at === null ? onTaskFinish() : onTaskUnfinish()
                        "
                        href="#"
                        role="button"
                    >
                        <span v-if="task_finished_at === null">
                            <i class="icofont-check"></i>{{ trans('Finish task') }}
                        </span>
                        <span v-else>
                            <i class="icofont-redo"></i>{{ trans('Unfinish task') }}
                        </span>
                    </a>
                </template>
                <template v-if="eventValues.teamId">
                    <div class="dropright">
                        <a
                            class="dropdown-item dropdown-toggle"
                            href="#"
                            role="button"
                            id="contextMenuAbsences"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <i class="icofont-adjust"></i>{{ trans('Absence') }}
                        </a>

                        <div class="dropdown-menu" aria-labelledby="contextMenuAbsences">
                            <a
                                class="dropdown-item"
                                v-for="absence of absence_types"
                                @click.stop="onAbsenceChangeTeam(absence.id)"
                                href="#"
                            >
                                <template v-if="absence.icon">
                                    <i :class="getIcon(absence.icon)"></i>
                                </template>
                                {{ absence.title }}
                            </a>
                        </div>
                    </div>
                </template>
                <template v-if="eventValues.slot">
                    <div class="dropright">
                        <a
                            class="dropdown-item dropdown-toggle"
                            href="#"
                            role="button"
                            id="contextMenuAbsences"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <span> <i class="icofont-adjust"></i>{{ trans('Status') }} </span>
                        </a>
                        <div class="dropdown-menu" aria-labelledby="contextMenuStatuses">
                            <a
                                class="dropdown-item"
                                v-for="status of task_statuses"
                                @click.prevent="onStatusChange(status.id)"
                                href="#"
                            >
                                {{ status.title }}
                            </a>
                        </div>
                    </div>
                    <a
                        class="dropdown-item"
                        @click.prevent="
                            task_finished_at === null ? onTaskFinish() : onTaskUnfinish()
                        "
                        href="#"
                        role="button"
                    >
                        <span v-if="task_finished_at === null">
                            <i class="icofont-check"></i>{{ trans('Finish task') }}
                        </span>
                        <span v-else>
                            <i class="icofont-redo"></i>{{ trans('Unfinish task') }}
                        </span>
                    </a>
                    <a
                        class="dropdown-item"
                        @click.prevent="onSlotDuplicate()"
                        href="#"
                        role="button"
                    >
                        <i class="icofont-ui-copy"></i>{{ trans('Duplicate') }}
                    </a>
                    <a
                        class="dropdown-item"
                        v-if="
                            eventValues.slot.firstOfGroup == 0 &&
                            eventValues.slot.lastOfGroup >= 0 &&
                            eventValues.slot.id != eventValues.slot.firstSlotId
                        "
                        @click.prevent="onSlotSplit()"
                        href="#"
                        role="button"
                    >
                        <i class="icofont-cut"></i>{{ trans('Split') }}
                    </a>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import { emitter } from '../../../plugins/Mitt';
import config from '../../schedule/config';
import { mapActions, mapState } from 'vuex';

function initialEventValuesState() {
    return {
        // The values passed by the event. The object is overwritten
        eventValues: {
            // All possible values
            personId: null,
            teamId: null,
            taskId: null,
            slot: null,
            date: null,
        },
    };
}
export default {
    data() {
        return {
            ...initialEventValuesState(),
            posY: 0,
            posX: 0,
            show: false,
            absence_types: {},
            task_statuses: {},
            task_finished_at: {},
            show: false,
        };
    },
    computed: {
        ...mapState('planning', ['mode']),
        style() {
            return {
                top: this.posY + 'px',
                left: this.posX + 'px',
            };
        },
    },
    methods: {
        ...mapActions('planning', ['requestItemSlots', 'requestItemAbsences']),
        positionMenu(top, left) {
            const largestHeight = window.innerHeight - this.$el.offsetHeight - 25;
            const largestWidth = window.innerWidth - this.$el.offsetWidth - 25;

            if (top > largestHeight) {
                top = largestHeight;
            }

            if (left > largestWidth) {
                left = largestWidth;
            }
            this.posY = top;
            this.posX = left;
        },
        getInfoForContextMenu() {
            let params = this.eventValues;
            const url = route('planning.get-data-for-context-menu-component');
            axios.get(url, { params }).then((response) => {
                this.absence_types = response.data.absence_types;
                this.absence_types.unshift({ id: 0, title: trans('None') });
                this.task_statuses = response.data.task_statuses;
                this.task_finished_at = response.data.task_finished_at;
                this.show = true;
            });
        },
        onAbsenceChange(absence_id) {
            if (absence_id === 0) {
                axios
                    .post(
                        route('absences.clear-absences-for-person', {
                            personId: this.eventValues.personId,
                        }),
                        {
                            date: this.eventValues.date.formatted,
                        },
                    )
                    .then(() => {
                        const personIds = [this.eventValues.personId];
                        emitter.emit('planning-absences-changed', { itemIds: personIds });
                        emitter.emit('hide-context-menu-component');
                    });

                return;
            }
            axios
                .post(route('absences.store'), {
                    absence_type_id: absence_id,
                    entity_id: this.eventValues.personId,
                    entity_type: 'person',
                    date_start: this.eventValues.date.formatted,
                    date_end: this.eventValues.date.formatted,
                    is_full_day: 1,
                })
                .then((response) => {
                    const personIds = [this.eventValues.personId];
                    emitter.emit('planning-absences-changed', { itemIds: personIds });
                    emitter.emit('hide-context-menu-component');
                })
                .catch(() => {});
        },
        onAbsenceChangeTeam(absence_type_id) {
            axios
                .post(route('absences.store'), {
                    absence_type_id: absence_type_id,
                    entity_id: this.eventValues.teamId,
                    entity_type: 'team',
                    date_start: this.eventValues.date.formatted,
                    date_end: this.eventValues.date.formatted,
                    is_full_day: 1,
                })
                .then((response) => {
                    const teamIds = [this.eventValues.teamId];
                    this.requestItemAbsences({ itemsIds: teamIds });
                    emitter.emit('hide-context-menu-component');
                })
                .catch(() => {});
        },
        getIcon(type) {
            let icon = null;
            switch (type) {
                case config.CELL_ICON_HOME:
                    icon = 'icofont-home';
                    break;
                case config.CELL_ICON_PLANE:
                    icon = 'icofont-airplane-alt';
                    break;
                case config.CELL_ICON_MEDICAL:
                    icon = 'icofont-medical-sign';
                    break;
                case config.CELL_ICON_WEATHER:
                    icon = 'icofont-rainy';
                    break;
                case config.CELL_ICON_EDUCTION:
                    icon = 'icofont-hat-alt';
                    break;
                case -1:
                    icon = 'icofont-minus';
                    break;
            }
            return icon;
        },
        //task
        onTaskFinish() {
            const id = this.eventValues.slot
                ? this.eventValues.slot.taskId
                : this.eventValues.taskId;
            axios
                .post(
                    route('task.set-task-as-finished', {
                        taskId: this.eventValues.slot
                            ? this.eventValues.slot.taskId
                            : this.eventValues.taskId,
                        slotId: this.eventValues.slot ? this.eventValues.slot.id : null,
                    }),
                )
                .then((response) => {
                    switch (this.mode) {
                        case 'project':
                            const taskIds = [id];
                            this.requestItemSlots({ itemsIds: taskIds });
                            break;
                        case 'person':
                            const personIds = response.data.personIds;
                            this.requestItemSlots({ itemsIds: personIds });
                            break;
                        case 'equipment':
                            const equipmentIds = response.data.equipmentIds;
                            this.requestItemSlots({ itemsIds: equipmentIds });
                            break;
                        case 'team':
                            const teamIds = response.data.teamIds;
                            this.requestItemSlots({ itemsIds: teamIds });
                            break;
                    }
                    this.close();
                })
                .catch(() => {});
        },
        onTaskUnfinish() {
            const id = this.eventValues.slot
                ? this.eventValues.slot.taskId
                : this.eventValues.taskId;
            axios
                .post(
                    route('task.set-task-as-un-finished', {
                        taskId: this.eventValues.slot
                            ? this.eventValues.slot.taskId
                            : this.eventValues.taskId,
                        slotId: this.eventValues.slot ? this.eventValues.slot.id : null,
                    }),
                )
                .then((response) => {
                    switch (this.mode) {
                        case 'project':
                            const taskIds = [id];
                            this.requestItemSlots({ itemsIds: taskIds });
                            break;
                        case 'equipment':
                            const equipmentIds = response.data.equipmentIds;
                            this.requestItemSlots({ itemsIds: equipmentIds });
                            break;
                        case 'person':
                            const personIds = response.data.personIds;
                            this.requestItemSlots({ itemsIds: personIds });
                            break;
                        case 'team':
                            const teamIds = response.data.teamIds;
                            this.requestItemSlots({ itemsIds: teamIds });
                            break;
                    }
                    this.close();
                })
                .catch(() => {});
        },
        onStatusChange(statusId) {
            const id = this.eventValues.slot
                ? this.eventValues.slot.taskId
                : this.eventValues.taskId;
            axios
                .post(route('task.set-new-status-for-task'), {
                    statusId: statusId,
                    taskId: this.eventValues.slot
                        ? this.eventValues.slot.taskId
                        : this.eventValues.taskId,
                    slotId: this.eventValues.slot ? this.eventValues.slot.id : null,
                })
                .then((response) => {
                    switch (this.mode) {
                        case 'project':
                            const taskIds = [id];
                            this.requestItemSlots({ itemsIds: taskIds });
                            break;
                        case 'person':
                            const personIds = response.data.personIds;
                            this.requestItemSlots({ itemsIds: personIds });
                            break;
                        case 'equipment':
                            const equipmentIds = response.data.equipmentIds;
                            this.requestItemSlots({ itemsIds: equipmentIds });
                            break;
                        case 'team':
                            const teamIds = response.data.teamIds;
                            this.requestItemSlots({ itemsIds: teamIds });
                            break;
                    }
                    this.close();
                })
                .catch(() => {});
        },
        onSlotDuplicate() {
            axios
                .post(
                    route('planning.duplicate-slot-on-planning', {
                        slotId: this.eventValues.slot.id,
                    }),
                )
                .then((response) => {
                    switch (this.mode) {
                        case 'project':
                            const taskIds = response.data.taskIds;
                            this.requestItemSlots({ itemsIds: taskIds });
                            break;
                        case 'person':
                            const personIds = response.data.personIds;
                            this.requestItemSlots({ itemsIds: personIds });
                            break;
                        case 'equipment':
                            const equipmentIds = response.data.equipmentIds;
                            this.requestItemSlots({ itemsIds: equipmentIds });
                            break;
                        case 'team':
                            const teamIds = response.data.teamIds;
                            this.requestItemSlots({ itemsIds: teamIds });
                            break;
                    }
                    this.close();
                })
                .catch((error) => {
                    if (error.response.status === 403) {
                        const errorMessage = trans("You don't have rights for this project");
                        emitter.emit('hide-context-menu-component');
                        emitter.emit('hide-slot-hover-info');
                        emitter.emit('hide-day-hover-info');
                        emitter.emit('show-message-modal', {
                            messageHtml: errorMessage,
                        });
                    }
                });
        },
        onSlotSplit() {
            axios
                .post(
                    route('planning.split-slot-on-planning', {
                        slotId: this.eventValues.slot.id,
                    }),
                )
                .then((response) => {
                    switch (this.mode) {
                        case 'project':
                            const taskIds = response.data.taskIds;
                            this.requestItemSlots({ itemsIds: taskIds });
                            break;
                        case 'person':
                            const personIds = response.data.personIds;
                            this.requestItemSlots({ itemsIds: personIds });
                            break;
                        case 'equipment':
                            const equipmentIds = response.data.equipmentIds;
                            this.requestItemSlots({ itemsIds: equipmentIds });
                            break;
                        case 'team':
                            const teamIds = response.data.teamIds;
                            this.requestItemSlots({ itemsIds: teamIds });
                            break;
                    }
                    this.close();
                })
                .catch(() => {});
        },
        close() {
            emitter.emit('hide-context-menu-component');
        },
    },
    mounted() {
        emitter.on('show-context-menu-component', ({ eventObject, event }) => {
            emitter.emit('hide-slot-hover-info');
            emitter.emit('hide-day-hover-info');
            this.$nextTick(() => {
                this.positionMenu(event.y, event.x);
            });
            this.eventValues = eventObject;
            this.getInfoForContextMenu();
            document.documentElement.style.overflow = 'hidden';
        });
        emitter.on('hide-context-menu-component', () => {
            Object.assign(this.$data, initialEventValuesState());
            this.show = false;
            document.documentElement.style.overflow = 'auto';
        });
    },
};
</script>
<style>
.context-menu-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
}
</style>
